'use client';
import React, { useState } from 'react';
import styled from '@benzinga/themetron';
import { MoneyServiceListItem, MoneyServiceListItemProps } from './MoneyServiceListItem';

export interface MoneyServicesListProps {
  service_tabs: MoneyServiceListItemProps[];
}

export const MoneyServicesList = ({ service_tabs }: MoneyServicesListProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  return (
    <MoneyServicesListWrapper className="money-services-list-wrapper">
      {service_tabs.map((block, i) => (
        <MoneyServiceListItem
          index={i}
          isActive={i === activeIndex}
          key={i}
          listItem={block}
          onClick={setActiveIndex}
        />
      ))}
    </MoneyServicesListWrapper>
  );
};

const MoneyServicesListWrapper = styled.div`
  &.money-services-list-wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

MoneyServicesList.defaultProps = {
  service_tabs: [
    {
      iconKey: 'insurance',
      lists: [
        {
          items: [
            { title: 'Best Car Insurance', url: '' },
            { title: 'Cheap Car Insurance', url: '' },
            { title: 'Car Insurance For Teens', url: '' },
            { title: 'How Much Car Insurance Do I Need?', url: '' },
            { title: 'Compare Car Insurance Quotes?', url: '' },
          ],
          title: 'Car Insurance',
        },
        {
          items: [
            { title: 'Travel Insurance', url: '' },
            { title: 'Best Pandemic Travel Insurance', url: '' },
            { title: 'CFAR Travel Insurance', url: '' },
            { title: 'Travel Insurance For Seniors Cruise Insurance', url: '' },
            { title: 'Compare Car Insurance Quotes', url: '' },
          ],
          title: 'Travel Insurance',
        },
        {
          items: [
            { title: 'Best Pet Insurance ', url: '' },
            { title: 'Best Pet Insurance For Pre-Existing Conditions ', url: '' },
            { title: 'How Much Does Pet Insurance Cost?', url: '' },
            { title: 'Pet Insurance Cover?', url: '' },
            { title: 'Compare Pet Insurance Quotes', url: '' },
          ],
          title: 'Pet Insurance',
        },
        {
          items: [
            { title: 'Best Life Insurance ', url: '' },
            { title: 'Best Term Life Insurance ', url: '' },
            { title: 'Best Whole Life Insurance ', url: '' },
            { title: 'Best Senior Life Insurance ', url: '' },
            { title: 'No-Exam Life Insurance', url: '' },
          ],
          title: 'Life Insurance',
        },
        {
          items: [
            { title: 'Best Car Insurance', url: '' },
            { title: 'Cheap Car Insurance', url: '' },
            { title: 'Car Insurance For Teens', url: '' },
            { title: 'How Much Car Insurance Do I Need?', url: '' },
            { title: 'Compare Car Insurance Quotes?', url: '' },
          ],
          title: 'Car Insurance',
        },
        {
          items: [
            { title: 'Travel Insurance', url: '' },
            { title: 'Best Pandemic Travel Insurance', url: '' },
            { title: 'CFAR Travel Insurance', url: '' },
            { title: 'Travel Insurance For Seniors Cruise Insurance', url: '' },
            { title: 'Compare Car Insurance Quotes', url: '' },
          ],
          title: 'Travel Insurance',
        },
        {
          items: [
            { title: 'Best Pet Insurance ', url: '' },
            { title: 'Best Pet Insurance For Pre-Existing Conditions ', url: '' },
            { title: 'How Much Does Pet Insurance Cost?', url: '' },
            { title: 'Pet Insurance Cover?', url: '' },
            { title: 'Compare Pet Insurance Quotes', url: '' },
          ],
          title: 'Pet Insurance',
        },
        {
          items: [
            { title: 'Best Life Insurance ', url: '' },
            { title: 'Best Term Life Insurance ', url: '' },
            { title: 'Best Whole Life Insurance ', url: '' },
            { title: 'Best Senior Life Insurance ', url: '' },
            { title: 'No-Exam Life Insurance', url: '' },
          ],
          title: 'Life Insurance',
        },
      ],
      title: 'Insurance',
    },
    {
      iconKey: 'credit_cards',
      lists: [
        {
          items: [
            { title: 'Best Car Insurance', url: '' },
            { title: 'Cheap Car Insurance', url: '' },
            { title: 'Car Insurance For Teens', url: '' },
            { title: 'How Much Car Insurance Do I Need?', url: '' },
            { title: 'Compare Car Insurance Quotes?', url: '' },
          ],
          title: 'Car Insurance',
        },
        {
          items: [
            { title: 'Travel Insurance', url: '' },
            { title: 'Best Pandemic Travel Insurance', url: '' },
            { title: 'CFAR Travel Insurance', url: '' },
            { title: 'Travel Insurance For Seniors Cruise Insurance', url: '' },
            { title: 'Compare Car Insurance Quotes', url: '' },
          ],
          title: 'Travel Insurance',
        },
        {
          items: [
            { title: 'Best Pet Insurance ', url: '' },
            { title: 'Best Pet Insurance For Pre-Existing Conditions ', url: '' },
            { title: 'How Much Does Pet Insurance Cost?', url: '' },
            { title: 'Pet Insurance Cover?', url: '' },
            { title: 'Compare Pet Insurance Quotes', url: '' },
          ],
          title: 'Pet Insurance',
        },
        {
          items: [
            { title: 'Best Life Insurance ', url: '' },
            { title: 'Best Term Life Insurance ', url: '' },
            { title: 'Best Whole Life Insurance ', url: '' },
            { title: 'Best Senior Life Insurance ', url: '' },
            { title: 'No-Exam Life Insurance', url: '' },
          ],
          title: 'Life Insurance',
        },
        {
          items: [
            { title: 'Best Car Insurance', url: '' },
            { title: 'Cheap Car Insurance', url: '' },
            { title: 'Car Insurance For Teens', url: '' },
            { title: 'How Much Car Insurance Do I Need?', url: '' },
            { title: 'Compare Car Insurance Quotes?', url: '' },
          ],
          title: 'Car Insurance',
        },
        {
          items: [
            { title: 'Travel Insurance', url: '' },
            { title: 'Best Pandemic Travel Insurance', url: '' },
            { title: 'CFAR Travel Insurance', url: '' },
            { title: 'Travel Insurance For Seniors Cruise Insurance', url: '' },
            { title: 'Compare Car Insurance Quotes', url: '' },
          ],
          title: 'Travel Insurance',
        },
        {
          items: [
            { title: 'Best Pet Insurance ', url: '' },
            { title: 'Best Pet Insurance For Pre-Existing Conditions ', url: '' },
            { title: 'How Much Does Pet Insurance Cost?', url: '' },
            { title: 'Pet Insurance Cover?', url: '' },
            { title: 'Compare Pet Insurance Quotes', url: '' },
          ],
          title: 'Pet Insurance',
        },
        {
          items: [
            { title: 'Best Life Insurance ', url: '' },
            { title: 'Best Term Life Insurance ', url: '' },
            { title: 'Best Whole Life Insurance ', url: '' },
            { title: 'Best Senior Life Insurance ', url: '' },
            { title: 'No-Exam Life Insurance', url: '' },
          ],
          title: 'Life Insurance',
        },
      ],
      title: 'Credit Cards',
    },
    {
      iconKey: 'banking',
      lists: [
        {
          items: [
            { title: 'Best Car Insurance', url: '' },
            { title: 'Cheap Car Insurance', url: '' },
            { title: 'Car Insurance For Teens', url: '' },
            { title: 'How Much Car Insurance Do I Need?', url: '' },
            { title: 'Compare Car Insurance Quotes?', url: '' },
          ],
          title: 'Car Insurance',
        },
        {
          items: [
            { title: 'Travel Insurance', url: '' },
            { title: 'Best Pandemic Travel Insurance', url: '' },
            { title: 'CFAR Travel Insurance', url: '' },
            { title: 'Travel Insurance For Seniors Cruise Insurance', url: '' },
            { title: 'Compare Car Insurance Quotes', url: '' },
          ],
          title: 'Travel Insurance',
        },
        {
          items: [
            { title: 'Best Pet Insurance ', url: '' },
            { title: 'Best Pet Insurance For Pre-Existing Conditions ', url: '' },
            { title: 'How Much Does Pet Insurance Cost?', url: '' },
            { title: 'Pet Insurance Cover?', url: '' },
            { title: 'Compare Pet Insurance Quotes', url: '' },
          ],
          title: 'Pet Insurance',
        },
        {
          items: [
            { title: 'Best Life Insurance ', url: '' },
            { title: 'Best Term Life Insurance ', url: '' },
            { title: 'Best Whole Life Insurance ', url: '' },
            { title: 'Best Senior Life Insurance ', url: '' },
            { title: 'No-Exam Life Insurance', url: '' },
          ],
          title: 'Life Insurance',
        },
        {
          items: [
            { title: 'Best Car Insurance', url: '' },
            { title: 'Cheap Car Insurance', url: '' },
            { title: 'Car Insurance For Teens', url: '' },
            { title: 'How Much Car Insurance Do I Need?', url: '' },
            { title: 'Compare Car Insurance Quotes?', url: '' },
          ],
          title: 'Car Insurance',
        },
        {
          items: [
            { title: 'Travel Insurance', url: '' },
            { title: 'Best Pandemic Travel Insurance', url: '' },
            { title: 'CFAR Travel Insurance', url: '' },
            { title: 'Travel Insurance For Seniors Cruise Insurance', url: '' },
            { title: 'Compare Car Insurance Quotes', url: '' },
          ],
          title: 'Travel Insurance',
        },
        {
          items: [
            { title: 'Best Pet Insurance ', url: '' },
            { title: 'Best Pet Insurance For Pre-Existing Conditions ', url: '' },
            { title: 'How Much Does Pet Insurance Cost?', url: '' },
            { title: 'Pet Insurance Cover?', url: '' },
            { title: 'Compare Pet Insurance Quotes', url: '' },
          ],
          title: 'Pet Insurance',
        },
        {
          items: [
            { title: 'Best Life Insurance ', url: '' },
            { title: 'Best Term Life Insurance ', url: '' },
            { title: 'Best Whole Life Insurance ', url: '' },
            { title: 'Best Senior Life Insurance ', url: '' },
            { title: 'No-Exam Life Insurance', url: '' },
          ],
          title: 'Life Insurance',
        },
      ],
      title: 'Banking',
    },
    {
      iconKey: 'investing_retirement_taxes',
      lists: [
        {
          items: [
            { title: 'Best Car Insurance', url: '' },
            { title: 'Cheap Car Insurance', url: '' },
            { title: 'Car Insurance For Teens', url: '' },
            { title: 'How Much Car Insurance Do I Need?', url: '' },
            { title: 'Compare Car Insurance Quotes?', url: '' },
          ],
          title: 'Car Insurance',
        },
        {
          items: [
            { title: 'Travel Insurance', url: '' },
            { title: 'Best Pandemic Travel Insurance', url: '' },
            { title: 'CFAR Travel Insurance', url: '' },
            { title: 'Travel Insurance For Seniors Cruise Insurance', url: '' },
            { title: 'Compare Car Insurance Quotes', url: '' },
          ],
          title: 'Travel Insurance',
        },
        {
          items: [
            { title: 'Best Pet Insurance ', url: '' },
            { title: 'Best Pet Insurance For Pre-Existing Conditions ', url: '' },
            { title: 'How Much Does Pet Insurance Cost?', url: '' },
            { title: 'Pet Insurance Cover?', url: '' },
            { title: 'Compare Pet Insurance Quotes', url: '' },
          ],
          title: 'Pet Insurance',
        },
        {
          items: [
            { title: 'Best Life Insurance ', url: '' },
            { title: 'Best Term Life Insurance ', url: '' },
            { title: 'Best Whole Life Insurance ', url: '' },
            { title: 'Best Senior Life Insurance ', url: '' },
            { title: 'No-Exam Life Insurance', url: '' },
          ],
          title: 'Life Insurance',
        },
        {
          items: [
            { title: 'Best Car Insurance', url: '' },
            { title: 'Cheap Car Insurance', url: '' },
            { title: 'Car Insurance For Teens', url: '' },
            { title: 'How Much Car Insurance Do I Need?', url: '' },
            { title: 'Compare Car Insurance Quotes?', url: '' },
          ],
          title: 'Car Insurance',
        },
        {
          items: [
            { title: 'Travel Insurance', url: '' },
            { title: 'Best Pandemic Travel Insurance', url: '' },
            { title: 'CFAR Travel Insurance', url: '' },
            { title: 'Travel Insurance For Seniors Cruise Insurance', url: '' },
            { title: 'Compare Car Insurance Quotes', url: '' },
          ],
          title: 'Travel Insurance',
        },
        {
          items: [
            { title: 'Best Pet Insurance ', url: '' },
            { title: 'Best Pet Insurance For Pre-Existing Conditions ', url: '' },
            { title: 'How Much Does Pet Insurance Cost?', url: '' },
            { title: 'Pet Insurance Cover?', url: '' },
            { title: 'Compare Pet Insurance Quotes', url: '' },
          ],
          title: 'Pet Insurance',
        },
        {
          items: [
            { title: 'Best Life Insurance ', url: '' },
            { title: 'Best Term Life Insurance ', url: '' },
            { title: 'Best Whole Life Insurance ', url: '' },
            { title: 'Best Senior Life Insurance ', url: '' },
            { title: 'No-Exam Life Insurance', url: '' },
          ],
          title: 'Life Insurance',
        },
      ],
      title: 'Investing, Retirement & Taxes',
    },
  ],
};
